import React from 'react';
import { Typography } from '@sm/wds-react';
import { T, defineMessages } from '@sm/intl';

import './forbidden-error.scss';

// put this into common error component strings file
const COPY = defineMessages({
  SORRY_MESSAGE: {
    id: 'ForbiddenError.sorryMessage',
    defaultMessage: "We're sorry",
    description: '[Type: Label][Vis.: med] - We are sorry message'
  },
  PERMISSIONS: {
    id: 'ForbiddenError.permissions',
    defaultMessage: 'You do not have permission to see this page.',
    description: '[Type: Label][Vis.: med] - We are sorry message'
  },
  CHECK_URL: {
    id: 'ForbiddenError.checkURL',
    defaultMessage:
      "Please check the URL you entered to make sure it's spelled correctly.",
    description: '[Type: Label][Vis.: med] - check URL subtitle'
  },
  HELP_FIND_WAY: {
    id: 'ForbiddenError.helpFindWay',
    defaultMessage:
      'Still not sure how to get to the page you want? Maybe we can help you find your way:',
    description: '[Type: Label][Vis.: med] - Help find your way subtitle'
  },
  HOME: {
    id: 'ForbiddenError.home',
    defaultMessage: 'Home',
    description:
      '[Type: Label][Vis.: med] - Home link in Five Hundred Error Message'
  },
  SITEMAP: {
    id: 'ForbiddenError.sitemap',
    defaultMessage: 'Sitemap',
    description:
      '[Type: Label][Vis.: med] - Sitemap link in Five Hundred Error Message'
  },
  HELP_CENTER: {
    id: 'ForbiddenError.helpCenter',
    defaultMessage: 'Help Center',
    description:
      '[Type: Label][Vis.: med] - Help Center link in Five Hundred Error Message'
  },
  TEMPLATES: {
    id: 'ForbiddenError.templates',
    defaultMessage: 'Templates',
    description:
      '[Type: Label][Vis.: med] - Templates link in Five Hundred Error Message'
  },
  LEARN_MORE: {
    id: 'ForbiddenError.learnMore',
    defaultMessage: 'Learn More',
    description:
      '[Type: Label][Vis.: med] - Learn More link in Five Hundred Error Message'
  }
});

const ForbiddenError = () => (
  <div className="sm-forbidden-error" data-testid="ForbiddenError">
    <div className="sm-forbidden-error__message-wrapper">
      <Typography variant="pageTitle">
        <T desc={COPY.SORRY_MESSAGE} />
      </Typography>
      <div className="sm-forbidden-error__message-container">
        <Typography
          component="section"
          variant="sectionTitle"
          className="wds-p-1"
        >
          <T desc={COPY.PERMISSIONS} />
        </Typography>
        <Typography component="div" variant="body" className="wds-p-1">
          <p>
            <T desc={COPY.CHECK_URL} />
          </p>
          <p>
            <T desc={COPY.HELP_FIND_WAY} />
          </p>
        </Typography>
        <div className="sm-forbidden-error__links-container">
          <ul className="sm-forbidden-error__links-list">
            <li className="sm-forbidden-error__links-list-item">
              <a href="/">
                <T desc={COPY.HOME} />
              </a>
            </li>
            <li className="sm-forbidden-error__links-list-item">
              <a href="/mp/sitemap/">
                <T desc={COPY.HOME} />
              </a>
            </li>
            <li className="sm-forbidden-error__links-list-item">
              <a href="https://help.surveymonkey.com/">
                <T desc={COPY.HELP_CENTER} />
              </a>
            </li>
            <li className="sm-forbidden-error__links-list-item">
              <a href="/mp/survey-templates/">
                <T desc={COPY.TEMPLATES} />
              </a>
            </li>
            <li className="sm-forbidden-error__links-list-item">
              <a href="/mp/take-a-tour/">
                <T desc={COPY.LEARN_MORE} />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default ForbiddenError;
